// ABOUTME: Device-tiered render-cap resolution — how many pennants we render at once.
// ABOUTME: Desktop gets the full cap; touch / low-memory / low-core devices get the smaller mobile cap.

// Tiered defaults. Mobile is deliberately conservative (fill-rate bound); raise
// after profiling on a real low-end device. Desktop is comfortable at 60fps once
// the beacon/ball fill-rate is gated (see the render-cap plan).
export const DEFAULT_RENDER_CAP = Object.freeze({ desktop: 10000, mobile: 6000 });

// Below these, treat the device as constrained regardless of pointer type.
const LOW_MEMORY_GB = 4;
const LOW_CORE_COUNT = 4;

// Pick the render cap for this device. `env` carries the cheap capability signals
// (coarse pointer, navigator.deviceMemory, navigator.hardwareConcurrency); any may
// be undefined (deviceMemory is absent on Safari/Firefox) and absence never
// downgrades. `config` overrides the tier values.
export function resolveRenderCap(env = {}, config = DEFAULT_RENDER_CAP) {
    const desktop = config?.desktop ?? DEFAULT_RENDER_CAP.desktop;
    const mobile = config?.mobile ?? DEFAULT_RENDER_CAP.mobile;

    const coarse = env?.coarsePointer === true;
    const mem = env?.deviceMemory;
    const cores = env?.hardwareConcurrency;
    const lowMemory = typeof mem === 'number' && mem <= LOW_MEMORY_GB;
    const lowCores = typeof cores === 'number' && cores <= LOW_CORE_COUNT;

    return coarse || lowMemory || lowCores ? mobile : desktop;
}
